<template>
    <div class="fullwidth-wrapper fullwidth-wrapper--momentum">
        <period-chart
            v-if="currentHoroscopeSign"
            :data="currentHoroscopeSign"></period-chart>
    </div>
</template>

<script>
// @ is an alias to /src

import {getHoroscope} from "@/utils/api/usersApi.js";

import PeriodChart from "@/components/charts/PeriodChart.vue";


export default {
    name: "HoroscopeGen",
    components : {
        PeriodChart : PeriodChart
    }, 
    props : {
        cycle:{
            type : Array,
            required : true
        }, 
        currentSign : {
            type : String,
            required : true 
        }
    },
    data() {
        return {
               
        };
    },
    computed : {
        currentHoroscopeSign() {
            if (this.cycle) {
                return this.cycle.filter((item) => {
                    return item.sign === this.currentSign;
                });
            }
            return;
        }
    },
    mounted () {
       
    },
    methods : {
           
    }
};
</script>
